function skAnimation() {
  const elements = document.querySelectorAll('[data-sk-animation]');
  
  const observerOptions = {
    root: null, // Default is the viewport
    rootMargin: "0px 0px 0px 0px",
    threshold: 0 // Trigger when 10% of the element is visible
  };
  
  const observerAnimations = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        const delay = el.getAttribute('data-sk-animation-delay') || 0;
        el?.classList.add('sk-animate-before-init');
        el?.style.setProperty('animation-delay', delay + 'ms');
        
        setTimeout(() => {
          el.classList.add('sk-animated');
          // Optionally, unobserve the element after animation (if you don't want to re-animate)
          observerAnimations.unobserve(el);
        }, delay);
      }
    });
  }, observerOptions);
  
  elements.forEach(el => {
    observerAnimations.observe(el);
  });
}

window.addEventListener("DOMContentLoaded", () => {
  skAnimation();
});

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", (event) => {
    skAnimation();
  });
  document.addEventListener("shopify:section:reorder", () => {
    skAnimation();
  });
}
